import NewPersonalityAssessmentModal from './NewPersonalityAssessmentModal';

export default NewPersonalityAssessmentModal;



// WEBPACK FOOTER //
// ./src/client/Components/NewPersonalityAssessmentModal/index.js